<template>
  <div>
    <div class="main-wrapper">
      <!--begin::sidebar-->
      <sidebar-component classMenu="BbmIndex"></sidebar-component>
      <!--end::sidebar-->

      <div class="page-wrapper">
        <!--begin::navbar-->
        <navbar-component></navbar-component>
        <!--end::navbar-->

        <!--begin::content-->
        <div class="page-content">
          <div
            class="d-flex justify-content-between align-items-center flex-wrap grid-margin"
          >
            <div>
              <h4 class="mb-12 mb-md-0"></h4>
            </div>

            <div class="col-lg-12 col-xl-12 stretch-card">
              <div class="card">
                <form
                  class="forms-sample"
                  @submit.prevent="submitData"
                  method="POST"
                >
                  <div class="card-header">
                    <h4 style="margin-right: 5px" class="float-start mx-10">
                      Load History Detail
                    </h4>
                    <br />
                  </div>
                  <div class="card-body">
                    <div class="row my-3">
                      <table>
                        <tr>
                          <th>Load Id</th>
                          <td>:</td>
                          <td>{{ forms.load_id }}</td>

                          <th>Carrier</th>
                          <td>:</td>
                          <td>{{ forms.carrier }}</td>

                          <!-- <th>Pick In</th>
                          <td>:</td>
                          <td>{{ forms.pick_in }}</td> -->

                          <th>Void Overide</th>
                          <td>:</td>
                          <td>{{ forms.void_overide_time }}</td>
                        </tr>

                        <tr>
                          <!-- <th>Shipwithreff</th>
                          <td>:</td>
                          <td>{{ forms.shipwith_ref }}</td> -->

                          <th>Nopol</th>
                          <td>:</td>
                          <td>{{ forms.vehicle_no }}</td>

                          <!-- <th>Pick Out</th>
                          <td>:</td>
                          <td>{{ forms.pick_out }}</td> -->

                          <th>Void Remarks</th>
                          <td>:</td>
                          <td>{{ forms.void_overide_remarks }}</td>
                        </tr>

                        <tr>
                          <!-- <th>Order No</th>
                          <td>:</td>
                          <td>{{ forms.order_no }}</td> -->

                          <th>Type Truck</th>
                          <td>:</td>
                          <td>{{ forms.truck_type }}</td>

                          <!-- <th>Dest In</th>
                          <td>:</td>
                          <td>{{ forms.drop_in }}</td> -->

                          <th>Void User</th>
                          <td>:</td>
                          <td>{{ forms.void_overide_user }}</td>
                        </tr>

                        <tr>
                          <!-- <th>Customer</th>
                          <td>:</td>
                          <td>{{ forms.customer_name }}</td> -->

                          <th>Pick Plan</th>
                          <td>:</td>
                          <td>{{ forms.pick_plan }}</td>

                          <!-- <th>Dest Out</th>
                          <td>:</td>
                          <td>{{ forms.drop_in }}</td> -->

                          <th>Catatan Load (driver)</th>
                          <td>:</td>
                          <td>
                            <textarea
                              v-model="forms.load_driver_remarks"
                              class="form-control"
                            ></textarea>
                          </td>
                        </tr>

                        <tr>
                          <th>Fieldman</th>
                          <td>:</td>
                          <td>{{ forms.fieldman }}</td>

                          <!-- <th>Origin</th>
                          <td>:</td>
                          <td>{{ forms.pick_name }}</td> -->

                          <th>Shipment Result</th>
                          <td>:</td>
                          <td>{{ forms.m_load_result }}</td>

                          <th></th>
                          <td></td>
                          <td></td>
                        </tr>

                        <tr>
                          <th>Nama Driver</th>
                          <td>:</td>
                          <td>{{ forms.driver_name }}</td>

                          <th>Drop Plan</th>
                          <td>:</td>
                          <td>{{ forms.dest_plan }}</td>

                          <th></th>
                          <td></td>
                          <td></td>

                          <th></th>
                          <td></td>
                          <td></td>
                        </tr>

                        <tr>
                          <th>NMK Driver</th>
                          <td>:</td>
                          <td>{{ forms.driver_nmk }}</td>

                          <!-- <th>Destination</th>
                          <td>:</td>
                          <td>{{ forms.dest_name }}</td> -->

                          <!-- <th></th>
                          <td></td>
                          <td></td> -->

                          <th>Catatan Load (Truck)</th>
                          <td></td>
                          <td>
                            <textarea
                              v-model="forms.load_truck_remarks"
                              class="form-control"
                            ></textarea>
                          </td>
                        </tr>
                      </table>
                    </div>
                    <hr />
                    <div class="row align-items-end my-3">
                      <!-- Pick In -->
                      <div class="col-md-2 col-6 mb-2">
                        <label class="form-label"
                          >Pick In <span class="wajib">*</span></label
                        >
                        <!-- <date-range-picker
                          style="width: 100%"
                          :disabled="
                            action == 'detail' || !permision_role.method_custom3
                          "
                          control-container-class="form-control"
                          :locale-data="locale"
                          v-model="dateFilterPickIn"
                          opens="center"
                          singleDatePicker="true"
                          :timePicker24Hour="true"
                          :timePicker="true"
                          :showWeekNumbers="false"
                        >
                        </date-range-picker> -->
                        <div class="position-relative">
                          <flat-pickr
                            ref="pickIn"
                            v-model="forms.pick_in_time"
                            :config="flatConfig"
                            class="form-control"
                            :disabled="isDisabled"
                          />

                          <!-- ICON KALENDER -->
                          <i
                            class="fa fa-calendar position-absolute"
                            style="right: 10px; top: 10px; cursor: pointer"
                            @click="openCalendar('pickIn')"
                          ></i>
                        </div>
                      </div>

                      <!-- Pick Out -->
                      <div class="col-md-2 col-6 mb-2">
                        <label class="form-label"
                          >Pick Out <span class="wajib">*</span></label
                        >
                        <!-- <date-range-picker
                          style="width: 100%"
                          :disabled="
                            action == 'detail' || !permision_role.method_custom3
                          "
                          control-container-class="form-control"
                          :locale-data="locale"
                          v-model="dateFilterPickOut"
                          opens="center"
                          singleDatePicker="true"
                          :timePicker24Hour="true"
                          :timePicker="true"
                          :showWeekNumbers="false"
                        >
                        </date-range-picker> -->
                        <div class="position-relative">
                          <flat-pickr
                            ref="pickOut"
                            v-model="forms.pick_out_time"
                            :config="flatConfig"
                            class="form-control"
                            :disabled="isDisabled"
                          />

                          <!-- ICON KALENDER -->
                          <i
                            class="fa fa-calendar position-absolute"
                            style="right: 10px; top: 10px; cursor: pointer"
                            @click="openCalendar('pickOut')"
                          ></i>
                        </div>
                      </div>

                      <!-- Dest In -->
                      <div class="col-md-2 col-6 mb-2">
                        <label class="form-label"
                          >Dest In <span class="wajib">*</span></label
                        >
                        <!-- <date-range-picker
                          style="width: 100%"
                          :disabled="
                            action == 'detail' || !permision_role.method_custom3
                          "
                          control-container-class="form-control"
                          :locale-data="locale"
                          v-model="dateFilterDestIn"
                          opens="center"
                          singleDatePicker="true"
                          :timePicker24Hour="true"
                          :timePicker="true"
                          :showWeekNumbers="false"
                        >
                        </date-range-picker> -->
                        <div class="position-relative">
                          <flat-pickr
                            ref="dropIn"
                            v-model="forms.drop_in_time"
                            :config="flatConfig"
                            class="form-control"
                            :disabled="isDisabled"
                          />

                          <!-- ICON KALENDER -->
                          <i
                            class="fa fa-calendar position-absolute"
                            style="right: 10px; top: 10px; cursor: pointer"
                            @click="openCalendar('dropIn')"
                          ></i>
                        </div>
                      </div>

                      <!-- Dest Out -->
                      <div class="col-md-2 col-6 mb-2">
                        <label class="form-label"
                          >Dest Out <span class="wajib">*</span></label
                        >
                        <!-- <date-range-picker
                          style="width: 100%"
                          :disabled="
                            action == 'detail' || !permision_role.method_custom3
                          "
                          control-container-class="form-control"
                          :locale-data="locale"
                          v-model="dateFilterDestOut"
                          opens="center"
                          singleDatePicker="true"
                          :timePicker24Hour="true"
                          :timePicker="true"
                          :showWeekNumbers="false"
                        >
                        </date-range-picker> -->
                        <div class="position-relative">
                          <flat-pickr
                            ref="dropOut"
                            v-model="forms.drop_out_time"
                            :config="flatConfig"
                            class="form-control"
                            :disabled="isDisabled"
                          />

                          <!-- ICON KALENDER -->
                          <i
                            class="fa fa-calendar position-absolute"
                            style="right: 10px; top: 10px; cursor: pointer"
                            @click="openCalendar('dropOut')"
                          ></i>
                        </div>
                      </div>

                      <!-- Update Button -->
                      <div
                        class="col-md-2 col-12 mb-2"
                        v-if="action == 'edit' && permision_role.method_custom3"
                      >
                        <label class="form-label d-block">&nbsp;</label>
                        <button
                          class="btn btn-danger w-100"
                          @click.prevent="updatePickDrop(forms.load_id)"
                        >
                          UPDATE
                        </button>
                      </div>
                    </div>

                    <div class="row my-3">
                      <h5 class="float-start mx-10">Pick</h5>
                      <div class="table-responsive">
                        <table class="table table-striped">
                          <tr>
                            <th>Action</th>
                            <th>ShipWithRef</th>
                            <th>Order No</th>
                            <th>Pick Name</th>
                            <th>Cust Name</th>
                            <th>Cust Dest</th>
                            <th>Arrive Pick</th>
                            <th>Start Pick</th>
                            <th>Finish Pick</th>
                            <th>Depart Pick</th>
                            <th>Pick Foto</th>
                            <th>Pick Sign</th>
                          </tr>

                          <tr v-if="forms.pick.length === 0">
                            <td colspan="9" class="text-center">
                              Data tidak tersedia
                            </td>
                          </tr>

                          <tr v-for="(res, index) in forms.pick" :key="index">
                            <!-- ACTION -->
                            <td>
                              <span
                                v-if="
                                  action == 'edit' &&
                                  permision_role.method_custom3
                                "
                                @click.prevent="handleActionPick(res)"
                              >
                                <i
                                  :class="
                                    res.is_edit
                                      ? 'mdi mdi-check'
                                      : 'mdi mdi-pencil'
                                  "
                                ></i>
                                {{ res.is_edit ? "Save" : "Edit" }}
                              </span>
                            </td>

                            <td>{{ res.shipwith_ref }}</td>
                            <td>{{ res.order_no }}</td>
                            <td>{{ res.pick_name }}</td>
                            <td>{{ res.customer_name }}</td>
                            <td>{{ res.customer_tujuan }}</td>

                            <!-- ARRIVE PICK -->
                            <td>
                              <div v-if="res.is_edit">
                                <input
                                  :value="
                                    formatToDatetimeLocal(res.arrive_pick)
                                  "
                                  @input="
                                    res.arrive_pick = formatFromDatetimeLocal(
                                      $event.target.value
                                    )
                                  "
                                  type="datetime-local"
                                  class="form-control form-control-sm"
                                />

                                <!-- <date-range-picker
                                    style="width: 100%"
                                    control-container-class="form-control"
                                    :locale-data="locale"
                                    :timePicker="true"
                                    :timePicker24Hour="true"
                                    :singleDatePicker="true"
                                    :showWeekNumbers="false"
                                    :autoUpdateInput="true"
                                    v-model="res.arrive_pick"
                                  />
                                 -->
                              </div>
                              <div v-else>
                                {{ res.arrive_pick }}
                              </div>
                            </td>

                            <!-- START PICK -->
                            <td>
                              <div v-if="res.is_edit">
                                <input
                                  type="datetime-local"
                                  :value="formatToDatetimeLocal(res.start_pick)"
                                  @input="
                                    res.start_pick = formatFromDatetimeLocal(
                                      $event.target.value
                                    )
                                  "
                                  class="form-control form-control-sm"
                                />
                              </div>
                              <div v-else>
                                {{ res.start_pick }}
                              </div>
                            </td>

                            <!-- FINISH PICK -->
                            <td>
                              <div v-if="res.is_edit">
                                <input
                                  type="datetime-local"
                                  :value="
                                    formatToDatetimeLocal(res.finish_pick)
                                  "
                                  @input="
                                    res.finish_pick = formatFromDatetimeLocal(
                                      $event.target.value
                                    )
                                  "
                                  class="form-control form-control-sm"
                                />
                              </div>
                              <div v-else>
                                {{ res.finish_pick }}
                              </div>
                            </td>

                            <!-- DEPART PICK -->
                            <td>
                              <div v-if="res.is_edit">
                                <input
                                  type="datetime-local"
                                  :value="
                                    formatToDatetimeLocal(res.depart_pick)
                                  "
                                  @input="
                                    res.depart_pick = formatFromDatetimeLocal(
                                      $event.target.value
                                    )
                                  "
                                  class="form-control form-control-sm"
                                />
                              </div>
                              <div v-else>
                                {{ res.depart_pick }}
                              </div>
                            </td>

                            <td>
                              <img
                                :src="res.pick_foto"
                                style="
                                  cursor: pointer;
                                  width: 100px;
                                  height: 100px;
                                "
                                @click="showImage(res.pick_foto)"
                              />
                            </td>

                            <td>
                              <img
                                :src="res.pick_sign"
                                style="
                                  cursor: pointer;
                                  width: 100px;
                                  height: 100px;
                                "
                                @click="showImage(res.pick_sign)"
                              />
                              <!-- <vue-easy-lightbox
                                  escDisabled
                                  moveDisabled
                                  :imgs="res.pick_sign"
                                 
                                ></vue-easy-lightbox>

                                <vue-easy-lightbox
                                  escDisabled
                                  moveDisabled
                                  :visible="visible"
                                  :imgs="res.pick_foto"
                                  :index="index"
                                  @hide="handleHide"
                                ></vue-easy-lightbox> -->
                            </td>
                          </tr>
                        </table>
                      </div>
                    </div>

                    <div class="row my-3">
                      <h5 class="float-start mx-10">Depart</h5>
                      <div class="table-responsive">
                        <table class="table table-striped">
                          <tr>
                            <th>Action</th>
                            <th>ShipWithRef</th>
                            <th>Order No</th>
                            <th>Dest Name</th>
                            <th>Cust Name</th>
                            <th>Cust Dest</th>
                            <th>Arrive Drop</th>
                            <th>Start Drop</th>
                            <th>Finish Drop</th>
                            <th>Depart Drop</th>
                            <th>Dest Foto</th>
                            <th>Dest Sign</th>
                          </tr>

                          <tr v-if="forms.drop.length === 0">
                            <td colspan="9" class="text-center">
                              Data tidak tersedia
                            </td>
                          </tr>

                          <tr v-for="(res, index) in forms.drop" :key="index">
                            <!-- ACTION -->
                            <td>
                              <span
                                v-if="
                                  action == 'edit' &&
                                  permision_role.method_custom3
                                "
                                @click.prevent="handleActionDest(res)"
                              >
                                <i
                                  :class="
                                    res.is_edit
                                      ? 'mdi mdi-check'
                                      : 'mdi mdi-pencil'
                                  "
                                ></i>
                                {{ res.is_edit ? "Save" : "Edit" }}
                              </span>
                            </td>

                            <td>{{ res.shipwith_ref }}</td>
                            <td>{{ res.order_no }}</td>
                            <td>{{ res.dest_name }}</td>
                            <td>{{ res.customer_name }}</td>
                            <td>{{ res.customer_tujuan }}</td>

                            <!-- ARRIVE PICK -->
                            <td>
                              <div v-if="res.is_edit">
                                <input
                                  :value="
                                    formatToDatetimeLocal(res.arrive_dest)
                                  "
                                  @input="
                                    res.arrive_dest = formatFromDatetimeLocal(
                                      $event.target.value
                                    )
                                  "
                                  type="datetime-local"
                                  class="form-control form-control-sm"
                                />
                              </div>
                              <div v-else>
                                {{ res.arrive_dest }}
                              </div>
                            </td>

                            <!-- START PICK -->
                            <td>
                              <div v-if="res.is_edit">
                                <input
                                  type="datetime-local"
                                  :value="formatToDatetimeLocal(res.start_dest)"
                                  @input="
                                    res.start_dest = formatFromDatetimeLocal(
                                      $event.target.value
                                    )
                                  "
                                  class="form-control form-control-sm"
                                />
                              </div>
                              <div v-else>
                                {{ res.start_dest }}
                              </div>
                            </td>

                            <!-- FINISH PICK -->
                            <td>
                              <div v-if="res.is_edit">
                                <input
                                  type="datetime-local"
                                  :value="
                                    formatToDatetimeLocal(res.finish_dest)
                                  "
                                  @input="
                                    res.finish_dest = formatFromDatetimeLocal(
                                      $event.target.value
                                    )
                                  "
                                  class="form-control form-control-sm"
                                />
                              </div>
                              <div v-else>
                                {{ res.finish_dest }}
                              </div>
                            </td>

                            <!-- DEPART PICK -->
                            <td>
                              <div v-if="res.is_edit">
                                <input
                                  type="datetime-local"
                                  :value="
                                    formatToDatetimeLocal(res.depart_dest)
                                  "
                                  @input="
                                    res.depart_dest = formatFromDatetimeLocal(
                                      $event.target.value
                                    )
                                  "
                                  class="form-control form-control-sm"
                                />
                              </div>
                              <div v-else>
                                {{ res.depart_dest }}
                              </div>
                            </td>

                            <td>
                              <img
                                :src="res.dest_foto"
                                style="
                                  cursor: pointer;
                                  width: 100px;
                                  height: 100px;
                                "
                                @click="showImage(res.dest_foto)"
                              />
                            </td>

                            <td>
                              <img
                                :src="res.dest_sign"
                                style="
                                  cursor: pointer;
                                  width: 100px;
                                  height: 100px;
                                "
                                @click="showImage(res.dest_sign)"
                              />
                            </td>
                          </tr>
                        </table>
                      </div>
                    </div>

                    <br />

                    <hr />

                    <div class="row my-3">
                      <h4 class="float-start mx-10">Request Muat</h4>
                      <div class="table-responsive">
                        <table class="table table-striped">
                          <tr>
                            <th>No</th>
                            <th>Keputusan</th>
                            <th>Order No</th>
                            <th>Pick Plan</th>
                            <th>Dest Plan</th>
                            <th>Dest Name</th>
                            <th>Keterangan Driver</th>
                            <th>Keterangan CT</th>
                            <th>User</th>
                          </tr>

                          <tr v-if="forms.req_muat.length === 0">
                            <td colspan="9" class="text-center">
                              Data tidak tersedia
                            </td>
                          </tr>

                          <tr
                            v-for="(res, index) in forms.req_muat"
                            :key="index"
                          >
                            <td>{{ index + 1 }}</td>
                            <td>{{ res.approve_pick }}</td>
                            <td>{{ res.order_no }}</td>
                            <td>{{ res.pick_plan }}</td>
                            <td>{{ res.dest_plan }}</td>
                            <td>{{ res.dest_name }}</td>
                            <td>{{ res.cannot_load_remarks }}</td>
                            <td>{{ res.ct_pick_remarks }}</td>
                            <td>{{ res.approve_pick_user }}</td>
                          </tr>
                        </table>
                      </div>
                    </div>

                    <div class="row my-3">
                      <h4 class="float-start mx-10">Request Bongkar</h4>
                      <div class="table-responsive">
                        <table class="table table-striped">
                          <tr>
                            <th>No</th>
                            <th>Keputusan</th>
                            <th>Order No</th>
                            <th>Pick Plan</th>
                            <th>Dest Plan</th>
                            <th>Dest Name</th>
                            <th>Keterangan Driver</th>
                            <th>Keterangan CT</th>
                            <th>User</th>
                          </tr>

                          <tr v-if="forms.req_bongkar.length === 0">
                            <td colspan="9" class="text-center">
                              Data tidak tersedia
                            </td>
                          </tr>

                          <tr
                            v-for="(res, index) in forms.req_bongkar"
                            :key="index"
                          >
                            <td>{{ index + 1 }}</td>
                            <td>{{ res.approve_drop }}</td>
                            <td>{{ res.order_no }}</td>
                            <td>{{ forms.pick_plan }}</td>
                            <td>{{ forms.dest_plan }}</td>
                            <td>{{ forms.dest_name }}</td>
                            <td>{{ res.cannot_load_remarks }}</td>
                            <td>{{ res.ct_drop_remarks }}</td>
                            <td>{{ res.approve_dest_user }}</td>
                          </tr>
                        </table>
                      </div>
                    </div>

                    <div class="row my-3">
                      <h4 class="float-start mx-10">Request Leadtime</h4>
                      <div class="table-responsive">
                        <table class="table table-striped">
                          <tr>
                            <th>No</th>
                            <th>Keputusan</th>
                            <th>Shipwithreff</th>
                            <th>Pick Plan</th>
                            <th>Pick Name</th>
                            <th>Dest Name</th>
                            <th>Keterangan Driver</th>
                            <th>Keterangan CT</th>
                            <th>User</th>
                          </tr>

                          <tr v-if="forms.req_leadtime.length === 0">
                            <td colspan="9" class="text-center">
                              Data tidak tersedia
                            </td>
                          </tr>

                          <tr
                            v-for="(res, index) in forms.req_leadtime"
                            :key="index"
                          >
                            <td>{{ index + 1 }}</td>
                            <td>{{ res.respon_sanggahan }}</td>
                            <td>{{ res.shipwith_reff }}</td>
                            <td>{{ forms.pick_plan }}</td>
                            <td>{{ forms.pick_name }}</td>
                            <td>{{ forms.dest_name }}</td>
                            <td>{{ res.remarks }}</td>
                            <td>{{ res.respon_remarks }}</td>
                            <td>{{ res.respon_user }}</td>
                          </tr>
                        </table>
                      </div>
                    </div>

                    <div class="row my-3">
                      <h4 class="float-start mx-10">Request Epod</h4>
                      <div class="table-responsive">
                        <table class="table table-striped">
                          <tr>
                            <th>No</th>

                            <th>Shipwithreff</th>
                            <th>Pick Plan</th>
                            <th>Pick Name</th>
                            <th>Dest Plan</th>
                            <th>location</th>
                            <th>Remarks</th>
                            <th>Status</th>
                            <th>Action</th>
                          </tr>

                          <tr v-if="forms.req_epod.length === 0">
                            <td colspan="9" class="text-center">
                              Data tidak tersedia
                            </td>
                          </tr>

                          <tr :key="index">
                            <td>1</td>
                            <td>{{ forms.req_epod.shipwith_reff }}</td>
                            <td>{{ forms.pick_plan }}</td>
                            <td>{{ forms.pick_name }}</td>
                            <td>{{ forms.dest_name }}</td>
                            <td>{{ forms.req_epod.location }}</td>
                            <td>{{ forms.req_epod.remarks }}</td>
                            <td>{{ forms.req_epod.status }}</td>
                            <td>
                              <a
                                href="#"
                                title="Detail"
                                @click.prevent="
                                  showDetailEpod(forms.req_epod.m_load_id)
                                "
                              >
                                <i
                                  class="mdi mdi-eye"
                                  style="font-size: 16px"
                                ></i>
                              </a>
                            </td>
                          </tr>
                        </table>
                      </div>
                    </div>

                    <div class="row my-3">
                      <h4 class="float-start mx-10">Request BA</h4>
                      <div class="table-responsive">
                        <table class="table table-striped">
                          <tr>
                            <th>No</th>
                            <th>Shipwithreff</th>
                            <th>Pick Plan</th>
                            <th>Pick Name</th>
                            <th>Dest Plan</th>
                            <th>Jumlah BA</th>
                            <th>Keterangan CT</th>
                            <th>Status</th>
                            <th>Action</th>
                          </tr>

                          <tr v-if="forms.req_ba === NULL">
                            <td colspan="9" class="text-center">
                              Data tidak tersedia
                            </td>
                          </tr>

                          <tr>
                            <td>1</td>
                            <td>{{ forms.req_ba.shipwith_reff }}</td>
                            <td>{{ forms.pick_plan }}</td>
                            <td>{{ forms.pick_name }}</td>
                            <td>{{ forms.dest_name }}</td>
                            <td>{{ forms.req_ba.jumlah_ba }}</td>
                            <td>{{ forms.req_ba.remarks }}</td>
                            <td>{{ forms.req_epod.status }}</td>
                            <td>
                              <a
                                href="#"
                                title="Detail"
                                @click.prevent="
                                  showDetailBa(forms.req_ba.m_load_id)
                                "
                              >
                                <i
                                  class="mdi mdi-eye"
                                  style="font-size: 16px"
                                ></i>
                              </a>
                            </td>
                          </tr>
                        </table>
                      </div>
                    </div>
                  </div>
                  <div class="card-footer">
                    <div
                      class="d-flex justify-content-between align-items-center flex-wrap"
                    >
                      <!-- Tombol Back -->
                      <button
                        class="btn btn-warning text-black fw-bolder btn-icon-text mb-2"
                        @click="backForm"
                        type="button"
                      >
                        <i class="link-icon" data-feather="arrow-left"></i>
                        {{ $t("backMess") }}
                      </button>

                      <!-- Tombol Submit & Void -->
                      <div class="d-flex gap-2" v-if="action == 'edit'">
                        <button class="btn btn-primary btn-sm" type="submit">
                          <i class="link-icon" data-feather="save"></i>
                          {{ $t("submitFormTxt") }}
                        </button>

                        <button
                          @click="cancelOrder"
                          v-if="
                            action == 'edit' && forms.void_overide_time == null
                          "
                          class="btn btn-primary btn-sm"
                          type="button"
                        >
                          <i class="link-icon" data-feather="save"></i>
                          VOID
                        </button>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>

        <vue-easy-lightbox
          escDisabled
          moveDisabled
          :visible="visible"
          :imgs="imgs"
          :index="index"
          @hide="handleHide"
        ></vue-easy-lightbox>
        <!--end::content-->
        <modal-void-overide
          :showModal="showModalVoid"
          :data="passData"
          @closeModal="closeMyModal"
        ></modal-void-overide>
        <!--begin::footer-->
        <footer-component></footer-component>
        <!--end::footer-->
      </div>
    </div>
  </div>
</template>
<script>
import sidebarComponent from "@/components/_partials/_sidebar";
import navbarComponent from "@/components/_partials/_navbar";
import footerComponent from "@/components/_partials/_footer";
import modalVoidOveride from "@/components/modal/modalVoidOveride.vue";
// import DirectionsRenderer from "@/middleware/DirectionsRenderer";
import VueEasyLightbox from "vue-easy-lightbox";

//import DateRangePicker from "vue2-daterange-picker";
import moment from "moment";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
// import moment from 'moment'

export default {
  name: "requestMuatDetail",
  components: {
    "sidebar-component": sidebarComponent,
    "navbar-component": navbarComponent,
    "footer-component": footerComponent,
    "modal-void-overide": modalVoidOveride,
    //DateRangePicker,
    VueEasyLightbox,
    flatPickr,

    // DirectionsRenderer
  },
  computed: {
    isDisabled() {
      return this.action == "detail" || !this.permision_role.method_custom3;
    },
  },
  data() {
    const startDate = moment().clone().startOf("month").format("YYYY-MM-DD"); // new Date();
    const endDate = new Date();
    return {
      flatConfig: {
        enableTime: true,
        enableSeconds: true,
        time_24hr: true,
        dateFormat: "Y-m-d H:i:S",
        allowInput: true,
        minuteIncrement: 1,
        secondIncrement: 1,
      },
      imgs: [],
      passData: {},
      visible: false,
      showModalVoid: false,
      maxToasts: 100,
      position: "up right",
      closeBtn: true,
      isLoading: false,
      dateFilterPickIn: {
        startDate,
        endDate,
      },
      dateFilterPickOut: {
        startDate,
        endDate,
      },
      dateFilterDestIn: {
        startDate,
        endDate,
      },

      dateFilterDestOut: {
        startDate,
        endDate,
      },

      locale: {
        format: "yyyy-mm-dd H:mm:ss",
      },
      errors: [],
      action: "",
      permision_role: [],
      langs: ["id", "en"],
      detailUser: [],
      detailDivisi: [],
      totalRecords: 0,
      forms: [],

      center: {
        lat: -2.548926,
        lng: 118.0148634,
      },
      waypnt: [],
      markers: [],
    };
  },
  watch: {},
  methods: {
    openCalendar(refName) {
      this.$refs[refName].fp.open(); // <------ buka kalender
    },
    backForm() {
      window.location.href = "/load-history";
    },

    handleHide() {
      this.visible = false;
    },

    show() {
      this.visible = true;
    },

    showImage(data) {
      console.log(data);
      this.imgs = data;
      this.show();
    },

    submitData_v1() {
      this.$swal({
        title: this.$t("areYouSure"),
        text: this.$t("yourDataSend"),
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes!",
      }).then((result) => {
        if (result.value) {
          this.loading();
          var formData = {
            approve_pick: this.forms.approve_pick,
            ct_pick_remarks: this.forms.ct_pick_remarks,
            pick_in_time: this.dateFilterPickIn.startDate,
            pick_out_time: this.dateFilterPickOut.startDate,
            drop_in_time: this.dateFilterDestIn.startDate,
            drop_out_time: this.dateFilterDestOut.startDate,
          };
          const baseURI =
            this.$settings.endPointLincMobile +
            "web/shipment/update-muat-bongkar/" +
            this.forms.m_shipment_id;
          this.$http
            .post(baseURI, formData)
            .then((response) => {
              this.loading();
              if (response.data.status === 200) {
                this.success(response.data.datas.messages);
                window.location.href = "/load-history";
              } else {
                this.errors = response.data.errors;
                this.resultError(response.data.errors);
              }
            })
            .catch((error) => {
              this.loading();
              if (error.response) {
                if (error.response.status === 422) {
                  this.errors = error.response.data.errors;
                  this.resultError(error.response.data.errors);
                } else if (error.response.status === 500) {
                  this.$router.push("/server-error");
                } else {
                  this.$router.push("/page-not-found");
                }
              }
            });
        }
      });
      // console.log(this.forms);
    },

    submitData() {
      this.$swal({
        title: this.$t("areYouSure"),
        text: this.$t("yourDataSend"),
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes!",
      }).then((result) => {
        if (result.value) {
          // KONVERSI KE MOMENT
          const pickIn = moment(this.forms.pick_in_time);
          const pickOut = moment(this.forms.pick_out_time);
          const destIn = moment(this.forms.drop_in_time);
          const destOut = moment(this.forms.drop_out_time);

          // =============================
          //   VALIDASI WAKTU SEPASANG
          // =============================

          // 1️⃣ Jika Pick In & Pick Out keduanya terisi → validasi PickOut > PickIn
          if (this.forms.pick_in_time && this.forms.pick_out_time) {
            if (!pickOut.isAfter(pickIn)) {
              this.$swal.fire({
                icon: "warning",
                title: "Validasi Waktu",
                text: "Waktu Pick Out harus lebih besar dari Pick In.",
                confirmButtonText: "OK",
              });
              return;
            }
          }

          // 2️⃣ Jika Pick Out & Dest In keduanya terisi → validasi DestIn > PickOut
          if (this.forms.pick_out_time && this.forms.drop_in_time) {
            if (!destIn.isAfter(pickOut)) {
              this.$swal.fire({
                icon: "warning",
                title: "Validasi Waktu",
                text: "Waktu Dest In harus lebih besar dari Pick Out.",
                confirmButtonText: "OK",
              });
              return;
            }
          }

          // 3️⃣ Jika Dest In & Dest Out keduanya terisi → validasi DestOut > DestIn
          if (this.forms.drop_in_time && this.forms.drop_out_time) {
            if (!destOut.isAfter(destIn)) {
              this.$swal.fire({
                icon: "warning",
                title: "Validasi Waktu",
                text: "Waktu Dest Out harus lebih besar dari Dest In.",
                confirmButtonText: "OK",
              });
              return;
            }
          }

          // =============================
          //        KIRIM KE BACKEND
          // =============================
          this.loading();

          const formData = {
            approve_pick: this.forms.approve_pick,
            ct_pick_remarks: this.forms.ct_pick_remarks,

            pick_in_time: pickIn.format("YYYY-MM-DD HH:mm:ss"),
            pick_out_time: pickOut.format("YYYY-MM-DD HH:mm:ss"),
            drop_in_time: destIn.format("YYYY-MM-DD HH:mm:ss"),
            drop_out_time: destOut.format("YYYY-MM-DD HH:mm:ss"),
          };

          const baseURI =
            this.$settings.endPointLincMobile +
            "web/shipment/update-muat-bongkar/" +
            this.forms.m_shipment_id;

          this.$http
            .post(baseURI, formData)
            .then((response) => {
              this.loading();
              if (response.data.status === 200) {
                this.success(response.data.datas.messages);
                window.location.href = "/load-history";
              } else {
                this.errors = response.data.errors;
                this.resultError(response.data.errors);
              }
            })
            .catch((error) => {
              this.loading();
              if (error.response) {
                if (error.response.status === 422) {
                  this.errors = error.response.data.errors;
                  this.resultError(error.response.data.errors);
                } else if (error.response.status === 500) {
                  this.$router.push("/server-error");
                } else {
                  this.$router.push("/page-not-found");
                }
              }
            });
        }
      });
    },

    updatePickDrop_v1(load_id) {
      const baseURI = `${this.$settings.endPointLincMobile}web/shipment/update-pick-drop/${load_id}`;
      console.log("Endpoint:", baseURI);

      this.$swal({
        title: this.$t("areYouSure"),
        text: this.$t("yourDataSend"),
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes!",
      }).then((result) => {
        if (result.value) {
          // Ambil waktu dari picker dan ubah ke moment object
          const pickOut = moment(String(this.dateFilterPickOut.startDate));
          const dropIn = moment(String(this.dateFilterDestIn.startDate));

          // 🔍 VALIDASI: Drop In tidak boleh lebih kecil dari Pick Out
          if (dropIn.isBefore(pickOut)) {
            this.$swal.fire({
              icon: "warning",
              title: "Validasi Waktu",
              text: "Waktu Drop In tidak boleh lebih kecil dari Pick Out!",
              confirmButtonText: "OK",
            });
            return; // ⛔ hentikan eksekusi
          }

          // ✅ Jika validasi lolos, lanjutkan kirim ke backend
          this.loading();

          const formData = {
            pick_in_time: moment(
              String(this.dateFilterPickIn.startDate)
            ).format("YYYY-MM-DD H:m:s"),
            pick_out_time: moment(
              String(this.dateFilterPickOut.startDate)
            ).format("YYYY-MM-DD H:m:s"),
            drop_in_time: moment(
              String(this.dateFilterDestIn.startDate)
            ).format("YYYY-MM-DD H:m:s"),
            drop_out_time: moment(
              String(this.dateFilterDestOut.startDate)
            ).format("YYYY-MM-DD H:m:s"),
          };

          console.log("Kirim ke:", baseURI, "Data:", formData);

          this.$http
            .post(baseURI, formData)
            .then((response) => {
              if (response.data.status === 200) {
                this.success(response.data.datas.messages);
                this.loadData();
              } else {
                this.errors = response.data.errors;
                this.resultError(response.data.errors);
              }
            })
            .catch((error) => {
              this.loading();
              if (error.response) {
                if (error.response.status === 422) {
                  this.errors = error.response.data.errors;
                  this.resultError(error.response.data.errors);
                } else if (error.response.status === 500) {
                  this.$router.push("/server-error");
                } else {
                  this.$router.push("/page-not-found");
                }
              }
            });
        }
      });
    },

    updatePickDrop(load_id) {
      const baseURI = `${this.$settings.endPointLincMobile}web/shipment/update-pick-drop/${load_id}`;
      console.log("Endpoint:", baseURI);

      this.$swal({
        title: this.$t("areYouSure"),
        text: this.$t("yourDataSend"),
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes!",
      }).then((result) => {
        if (result.value) {
          // === LOG DEBUG ===
          console.log("=== INPUTAN USER ===");
          console.log("pick_in_time :", this.forms.pick_in_time);
          console.log("pick_out_time:", this.forms.pick_out_time);
          console.log("drop_in_time :", this.forms.drop_in_time);
          console.log("drop_out_time:", this.forms.drop_out_time);

          // Konversi moment
          const pickIn = this.forms.pick_in_time
            ? moment(this.forms.pick_in_time)
            : null;
          const pickOut = this.forms.pick_out_time
            ? moment(this.forms.pick_out_time)
            : null;
          const destIn = this.forms.drop_in_time
            ? moment(this.forms.drop_in_time)
            : null;
          const destOut = this.forms.drop_out_time
            ? moment(this.forms.drop_out_time)
            : null;

          console.log("=== MOMENT PARSED ===");
          if (pickIn)
            console.log("pickIn :", pickIn.format("YYYY-MM-DD HH:mm:ss"));
          if (pickOut)
            console.log("pickOut:", pickOut.format("YYYY-MM-DD HH:mm:ss"));
          if (destIn)
            console.log("destIn :", destIn.format("YYYY-MM-DD HH:mm:ss"));
          if (destOut)
            console.log("destOut:", destOut.format("YYYY-MM-DD HH:mm:ss"));

          // =============================
          // 🔥 VALIDASI BERURUTAN (SEPASANG)
          // =============================

          // 1. Validasi Pick In & Pick Out jika dua-duanya isi
          if (pickIn && pickOut) {
            if (!pickOut.isAfter(pickIn)) {
              this.$swal.fire({
                icon: "warning",
                title: "Validasi Waktu",
                text: "Waktu Pick Out harus lebih besar dari Pick In.",
                confirmButtonText: "OK",
              });
              return;
            }
          }

          // 2. Validasi Pick Out & Dest In jika dua-duanya isi
          if (pickOut && destIn) {
            if (!destIn.isAfter(pickOut)) {
              this.$swal.fire({
                icon: "warning",
                title: "Validasi Waktu",
                text: "Waktu Dest In harus lebih besar dari Pick Out.",
                confirmButtonText: "OK",
              });
              return;
            }
          }

          // 3. Validasi Dest In & Dest Out jika dua-duanya isi
          if (destIn && destOut) {
            if (!destOut.isAfter(destIn)) {
              this.$swal.fire({
                icon: "warning",
                title: "Validasi Waktu",
                text: "Waktu Dest Out harus lebih besar dari Dest In.",
                confirmButtonText: "OK",
              });
              return;
            }
          }

          // =============================
          // 🚀 KIRIM KE BACKEND
          // =============================
          this.loading();

          const formData = {
            pick_in_time: pickIn ? pickIn.format("YYYY-MM-DD HH:mm:ss") : null,
            pick_out_time: pickOut
              ? pickOut.format("YYYY-MM-DD HH:mm:ss")
              : null,
            drop_in_time: destIn ? destIn.format("YYYY-MM-DD HH:mm:ss") : null,
            drop_out_time: destOut
              ? destOut.format("YYYY-MM-DD HH:mm:ss")
              : null,
          };

          console.log("=== FINAL FORM DATA ===", formData);

          this.$http
            .post(baseURI, formData)
            .then((response) => {
              if (response.data.status === 200) {
                this.success(response.data.datas.messages);
                this.loadData();
              } else {
                this.errors = response.data.errors;
                this.resultError(response.data.errors);
              }
            })
            .catch((error) => {
              this.loading();
              if (error.response) {
                if (error.response.status === 422) {
                  this.errors = error.response.data.errors;
                  this.resultError(error.response.data.errors);
                } else if (error.response.status === 500) {
                  this.$router.push("/server-error");
                } else {
                  this.$router.push("/page-not-found");
                }
              }
            });
        }
      });
    },

    handleActionPick(res) {
      if (res.is_edit) {
        // Jika sedang edit, maka simpan data
        this.submitDataRowPick(res);
        res.is_edit = false;
      } else {
        // Jika belum edit, aktifkan edit mode
        res.is_edit = true;
      }
    },
    submitDataRowPick(row) {
      this.$swal({
        title: this.$t("areYouSure"),
        text: this.$t("yourDataSend"),
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes!",
      }).then((result) => {
        if (result.value) {
          var formData = {
            m_shipment_id: row.m_shipment_id,
            type: "pick",
            arrive_pick: row.arrive_pick,
            depart_pick: row.depart_pick,
            start_pick: row.start_pick,
            finish_pick: row.finish_pick,
          };
          const baseURI =
            this.$settings.endPointLincMobile +
            "web/shipment/update-pick-depart";
          this.$http
            .post(baseURI, formData)
            .then((response) => {
              this.loading();
              if (response.data.status === 200) {
                this.success("success");
                this.loadData();
              } else {
                this.errors = response.data.errors;
                this.resultError(response.data.errors);
              }
            })
            .catch((error) => {
              this.loading();
              if (error.response) {
                if (error.response.status === 422) {
                  this.errors = error.response.data.errors;
                  this.resultError(error.response.data.errors);
                } else if (error.response.status === 500) {
                  this.$router.push("/server-error");
                } else {
                  this.$router.push("/page-not-found");
                }
              }
            });
        }
      });
      // console.log(this.forms);
    },

    handleActionDest(res) {
      if (res.is_edit) {
        // Jika sedang edit, maka simpan data
        this.submitDataRowDest(res);
        res.is_edit = false;
      } else {
        // Jika belum edit, aktifkan edit mode
        res.is_edit = true;
      }
    },
    submitDataRowDest(row) {
      this.$swal({
        title: this.$t("areYouSure"),
        text: this.$t("yourDataSend"),
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes!",
      }).then((result) => {
        if (result.value) {
          var formData = {
            m_shipment_id: row.m_shipment_id,
            type: "depart",
            arrive_dest: row.arrive_dest,
            depart_dest: row.depart_dest,
            start_dest: row.start_dest,
            finish_dest: row.finish_dest,
          };
          // arrive_dest,start_dest,finish_dest,depart_dest
          const baseURI =
            this.$settings.endPointLincMobile +
            "web/shipment/update-pick-depart";
          this.$http
            .post(baseURI, formData)
            .then((response) => {
              this.loading();
              if (response.data.status === 200) {
                this.success("sucess");
                this.loadData();
              } else {
                this.errors = response.data.errors;
                this.resultError(response.data.errors);
              }
            })
            .catch((error) => {
              this.loading();
              if (error.response) {
                if (error.response.status === 422) {
                  this.errors = error.response.data.errors;
                  this.resultError(error.response.data.errors);
                } else if (error.response.status === 500) {
                  this.$router.push("/server-error");
                } else {
                  this.$router.push("/page-not-found");
                }
              }
            });
        }
      });
      // console.log(this.forms);
    },

    createData() {
      window.location.href = "/master-bbm/add";
    },

    uploadData() {
      window.location.href = "/master-bbm/upload";
    },

    closeMyModal() {
      this.showModalVoid = false;
      this.loadItems();
    },

    showDetailEpod(m_load_id) {
      const baseURI =
        this.$settings.endPointLincMobile +
        `/mobile/m-epod/detail/${m_load_id}`;

      this.$http
        .get(baseURI)
        .then((response) => {
          const podData = response.data.datas.pod;
          console.log(podData);

          // Jika datanya ada
          if (podData.length > 0) {
            const imagesHtml = podData
              .map((item) => {
                return `
            <div style="
              display: inline-block; 
              margin: 10px; 
              width: 120px; 
              text-align: center; 
              background-color: #f5f5f5; 
              border-radius: 8px; 
              padding: 10px; 
              box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);">
              
              <img src="${item.value}" 
                   alt="Image" 
                   style="width: 100px; height: 100px; object-fit: cover; border-radius: 5px;" />
              
              <div style="margin-top: 8px; font-size: 13px; color: #333;">
                <span style="display: block; font-weight: bold; color: ${
                  item.status === "APPROVE" ? "#28a745" : "#dc3545"
                };">
                  ${item.status}
                </span>
                <span style="display: block; margin-top: 4px; color: #555;">
                 ${item.remarks == null ? "" : item.remarks}
                </span>
              </div>
            </div>
          `;
              })
              .join("");

            this.$swal({
              title: "Detail POD",
              html: `<div style="display: flex; flex-wrap: wrap;">${imagesHtml}</div>`,
              width: "600px",
              padding: "20px",
              showCloseButton: true,
            });
          } else {
            this.$swal({
              title: "No Images",
              text: "Tidak ada gambar yang ditemukan.",
              icon: "info",
              showCloseButton: true,
            });
          }
        })
        .catch((error) => {
          console.error("Error:", error);
          this.$swal({
            title: "Error",
            text: "Gagal mengambil data / tidak ada data",
            icon: "error",
            showCloseButton: true,
          });
        });
    },

    formatToDatetimeLocal(value) {
      if (!value) return "";
      const date = new Date(value);
      const pad = (n) => n.toString().padStart(2, "0");
      return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(
        date.getDate()
      )}T${pad(date.getHours())}:${pad(date.getMinutes())}`;
    },
    formatFromDatetimeLocal(value) {
      if (!value) return "";
      const [datePart, timePart] = value.split("T");
      return `${datePart} ${timePart}:00`;
    },

    showDetailBa(m_load_id) {
      console.log(m_load_id);
      const baseURI =
        this.$settings.endPointLincMobile +
        `/mobile/m-berita-acara/detail/${m_load_id}`;

      this.$http
        .get(baseURI)
        .then((response) => {
          const baData = response.data.datas.ba;

          // Jika datanya ada
          if (baData.length > 0) {
            const imagesHtml = baData
              .map((item) => {
                return `
            <div style="
              display: inline-block; 
              margin: 10px; 
              width: 120px; 
              text-align: center; 
              background-color: #f5f5f5; 
              border-radius: 8px; 
              padding: 10px; 
              box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);">
              
              <img src="${item.value}" 
                   alt="Image" 
                   style="width: 100px; height: 100px; object-fit: cover; border-radius: 5px;" />
              
              <div style="margin-top: 8px; font-size: 13px; color: #333;">
                <span style="display: block; font-weight: bold; color: ${
                  item.status === "APPROVE" ? "#28a745" : "#dc3545"
                };">
                  ${item.status}
                </span>
                <span style="display: block; margin-top: 4px; color: #555;">
                  ${item.remarks == null ? "" : item.remarks}
                </span>
              </div>
            </div>
          `;
              })
              .join("");

            this.$swal({
              title: "Detail POD",
              html: `<div style="display: flex; flex-wrap: wrap;">${imagesHtml}</div>`,
              width: "600px",
              padding: "20px",
              showCloseButton: true,
            });
          } else {
            this.$swal({
              title: "No Images",
              text: "Tidak ada gambar yang ditemukan.",
              icon: "info",
              showCloseButton: true,
            });
          }
        })
        .catch((error) => {
          console.error("Error:", error);
          this.$swal({
            title: "Error",
            text: "Gagal mengambil data / tidak ada data",
            icon: "error",
            showCloseButton: true,
          });
        });
    },

    editData(index, row) {
      var params = this.$onRandom(row.rm_fuel_master_id);
      window.location.href = "/master-bbm/edit/" + params;
    },

    detailData(index, row) {
      var params = this.$onRandom(row.rm_fuel_master_id);
      window.location.href = "/master-bbm/detail/" + params;
    },

    updateParams(newProps) {
      this.serverParams = Object.assign({}, this.serverParams, newProps);
      this.loadItems();
    },

    onColumnFilter(params) {
      params.page = 1;
      this.updateParams(params);
    },

    onPageChange(params) {
      this.updateParams({ page: params.currentPage });
    },

    onSortChange(params) {
      this.updateParams({
        sort: {
          type: params[0].type,
          field: params[0].field,
        },
      });
    },

    onPerPageChange(params) {
      this.updateParams({ per_page: params.currentPerPage });
    },

    resultError(data) {
      var count = Object.keys(data).length;
      for (var x = 0; x < count; x++) {
        var nameOb = Object.keys(data)[x];
        var objectData = data[nameOb];
        for (var y = 0; y < objectData.length; y++) {
          this.error(objectData[y]);
        }
      }
    },

    success(kata) {
      const Toast = this.$swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener("mouseenter", this.$swal.stopTimer);
          toast.addEventListener("mouseleave", this.$swal.resumeTimer);
        },
      });
      Toast.fire({
        icon: "success",
        title: kata,
      });
    },

    //ini function button
    filterSearch() {
      const periodCodeFilterElement = document.querySelector(
        '[name="vgt-period_code"]'
      ); //ini setiap field pasti ada vgt-

      const periodNameFilterElement = document.querySelector(
        '[name="vgt-period_name"]'
      ); //ini setiap field pasti ada vgt-

      var params = {
        columnFilters: {
          period_code: periodCodeFilterElement.value,
          period_name: periodNameFilterElement.value,
          price: "",
          price_gap: "",
          effective_date: "",
          expired_date: "",
        },
        page: 1,
      }; // params yang di kirim

      this.updateParams(params); //ini untuk update params vue good table
    },

    error(kata) {
      const Toast = this.$swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener("mouseenter", this.$swal.stopTimer);
          toast.addEventListener("mouseleave", this.$swal.resumeTimer);
        },
      });
      Toast.fire({
        icon: "error",
        title: kata,
      });
    },

    fade(sType) {
      this.isLoading = sType;
    },

    cancelOrder() {
      this.showModalVoid = true;
      this.passData = this.forms;
    },

    loading() {
      this.fade(true);
      setTimeout(() => {
        this.isLoading = false;
      }, 1000); // hide the message after 3 seconds
    },

    fetchIt() {
      const userDatas = this.$getUserInfo();
      this.detailUser = userDatas.sub;
      // this.permision_role = userDatas.sub.permision_role;
      let rolePermision = [];
      userDatas.sub.permision_role.forEach(function (permision) {
        if (permision.permission.controller == "MLoadController") {
          rolePermision = permision;
          // console.log(permision);
        }
      });
      if (!rolePermision.method_read) {
        this.$router.push("/authorized-error");
      }
      this.permision_role = rolePermision;
    },

    makeDateRange(datetime) {
      if (!datetime) return { startDate: null, endDate: null };

      const m = moment(datetime, "YYYY-MM-DD H:M:s");

      return {
        startDate: m.clone(),
        endDate: m.clone(),
      };
    },

    loadData() {
      let segments = this.$route.path.split("/");
      this.action = segments[2]; // index ke-2 = 'edit'

      let params = this.$onBehind(this.$route.params.id);
      console.log(params);
      let idDetail = params;
      const baseURI =
        this.$settings.endPointLincMobile +
        "web/shipment/load-history/detail/" +
        idDetail;
      return this.$http.get(baseURI).then((response) => {
        console.log(response);
        this.forms = response.data.datas;

        if (Array.isArray(this.forms.pick)) {
          this.forms.pick = this.forms.pick.map((item) => ({
            ...item,
            is_edit: false,
          }));
        }

        if (Array.isArray(this.forms.drop)) {
          this.forms.drop = this.forms.drop.map((item) => ({
            ...item,
            is_edit: false,
          }));
        }

        this.dateFilterPickIn = {
          startDate: this.forms.pick_in_time,
          endDate: this.forms.pick_in_time,
        };

        this.dateFilterPickOut = this.makeDateRange(this.forms.pick_out_time);
        this.dateFilterDestIn = this.makeDateRange(this.forms.drop_in_time);
        this.dateFilterDestOut = this.makeDateRange(this.forms.drop_out_time);
        // this.loading();
        // this.rows = response.data.datas.data;
        // this.totalRecords = response.data.datas.total;
      });
    },

    logout() {
      this.$logoutUser();
      this.$router.push("/");
    },
    getTruckLocation() {
      const baseURI = this.$settings.endPointCt + "real-monitoring/get";
      this.isLoading = true;
      return this.$http
        .get(baseURI + `?vehicle_no=${this.forms.vehicle_no}`)
        .then((response) => {
          this.loading();
          if (response.data.status == 200) {
            let data = response.data.datas.data[0];
            this.center = {
              lat: data.latitude,
              lng: data.longitude,
            };
            this.markers.push({
              position: {
                lat: data.latitude,
                lng: data.longitude,
              },
            });
          }
        });
    },
  },
  events: {},
  created: function () {},
  mounted() {
    this.fetchIt();
    this.loading();
    this.loadData();
    //let params = this.$route.params;
  },
};
</script>

<style scoped>
th {
  color: #7b8289 !important;
}
</style>
